export default "__VITE_ASSET__DiS02ocW__"